// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetIsDisabled = () => getDefaultState().isPrintClaimDisabled;

const updateIsDisabled = (state, action) => action.isDisabled;

export default (state = getDefaultState().isPrintClaimDisabled, action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED]: resetIsDisabled,
        [actions.UPDATE_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED]: updateIsDisabled
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/is-print-claim-disabled.js